interface Country {
  name:      string
  dial_code: string
  code:      string
  flag:      string
}

const countries : { [key: string]: Country } = {
  "AF": {
    "name": "Afghanistan",
    "dial_code": "+93",
    "code": "AF",
    "flag": "\ud83c\udde6\ud83c\uddeb"
  },
  "AX": {
    "name": "\u00c5land Islands",
    "dial_code": "+358",
    "code": "AX",
    "flag": "\ud83c\udde6\ud83c\uddfd"
  },
  "AL": {
    "name": "Albania",
    "dial_code": "+355",
    "code": "AL",
    "flag": "\ud83c\udde6\ud83c\uddf1"
  },
  "DZ": {
    "name": "Algeria",
    "dial_code": "+213",
    "code": "DZ",
    "flag": "\ud83c\udde9\ud83c\uddff"
  },
  "AS": {
    "name": "American Samoa",
    "dial_code": "+1684",
    "code": "AS",
    "flag": "\ud83c\uddfa\ud83c\uddf8"
  },
  "AD": {
    "name": "Andorra",
    "dial_code": "+376",
    "code": "AD",
    "flag": "\ud83c\udde6\ud83c\udde9"
  },
  "AO": {
    "name": "Angola",
    "dial_code": "+244",
    "code": "AO",
    "flag": "\ud83c\udde6\ud83c\uddf4"
  },
  "AI": {
    "name": "Anguilla",
    "dial_code": "+1264",
    "code": "AI",
    "flag": "\ud83c\udde6\ud83c\uddee"
  },
  "AQ": {
    "name": "Antarctica",
    "dial_code": "+672",
    "code": "AQ",
    "flag": "\ud83c\udde6\ud83c\uddf6"
  },
  "AG": {
    "name": "Antigua and Barbuda",
    "dial_code": "+1268",
    "code": "AG",
    "flag": "\ud83c\udde6\ud83c\uddec"
  },
  "AR": {
    "name": "Argentina",
    "dial_code": "+54",
    "code": "AR",
    "flag": "\ud83c\udde6\ud83c\uddf7"
  },
  "AM": {
    "name": "Armenia",
    "dial_code": "+374",
    "code": "AM",
    "flag": "\ud83c\udde6\ud83c\uddf2"
  },
  "AW": {
    "name": "Aruba",
    "dial_code": "+297",
    "code": "AW",
    "flag": "\ud83c\udde6\ud83c\uddfc"
  },
  "AU": {
    "name": "Australia",
    "dial_code": "+61",
    "code": "AU",
    "flag": "\ud83c\udde6\ud83c\uddfa"
  },
  "AT": {
    "name": "Austria",
    "dial_code": "+43",
    "code": "AT",
    "flag": "\ud83c\udde6\ud83c\uddf9"
  },
  "AZ": {
    "name": "Azerbaijan",
    "dial_code": "+994",
    "code": "AZ",
    "flag": "\ud83c\udde6\ud83c\uddff"
  },
  "BS": {
    "name": "Bahamas",
    "dial_code": "+1242",
    "code": "BS",
    "flag": "\ud83c\udde7\ud83c\uddf8"
  },
  "BH": {
    "name": "Bahrain",
    "dial_code": "+973",
    "code": "BH",
    "flag": "\ud83c\udde7\ud83c\uddf8"
  },
  "BD": {
    "name": "Bangladesh",
    "dial_code": "+880",
    "code": "BD",
    "flag": "\ud83c\udde7\ud83c\udde9"
  },
  "BB": {
    "name": "Barbados",
    "dial_code": "+1246",
    "code": "BB",
    "flag": "\ud83c\udde7\ud83c\udde7"
  },
  "BY": {
    "name": "Belarus",
    "dial_code": "+375",
    "code": "BY",
    "flag": "\ud83c\udde7\ud83c\uddfe"
  },
  "BE": {
    "name": "Belgium",
    "dial_code": "+32",
    "code": "BE",
    "flag": "\ud83c\udde7\ud83c\uddea"
  },
  "BZ": {
    "name": "Belize",
    "dial_code": "+501",
    "code": "BZ",
    "flag": "\ud83c\udde7\ud83c\uddff"
  },
  "BJ": {
    "name": "Benin",
    "dial_code": "+229",
    "code": "BJ",
    "flag": "\ud83c\udde7\ud83c\uddef"
  },
  "BM": {
    "name": "Bermuda",
    "dial_code": "+1441",
    "code": "BM",
    "flag": "\ud83c\udde7\ud83c\uddf2"
  },
  "BT": {
    "name": "Bhutan",
    "dial_code": "+975",
    "code": "BT",
    "flag": "\ud83c\udde7\ud83c\uddf9"
  },
  "BO": {
    "name": "Bolivia, Plurinational State of bolivia",
    "dial_code": "+591",
    "code": "BO",
    "flag": "\ud83c\udde7\ud83c\uddf4"
  },
  "BA": {
    "name": "Bosnia and Herzegovina",
    "dial_code": "+387",
    "code": "BA",
    "flag": "\ud83c\udde7\ud83c\udde6"
  },
  "BW": {
    "name": "Botswana",
    "dial_code": "+267",
    "code": "BW",
    "flag": "\ud83c\udde7\ud83c\uddfc"
  },
  "BV": {
    "name": "Bouvet Island",
    "dial_code": "+47",
    "code": "BV",
    "flag": "\ud83c\udff3"
  },
  "BR": {
    "name": "Brazil",
    "dial_code": "+55",
    "code": "BR",
    "flag": "\ud83c\udde7\ud83c\uddf7"
  },
  "IO": {
    "name": "British Indian Ocean Territory",
    "dial_code": "+246",
    "code": "IO",
    "flag": "\ud83c\uddee\ud83c\uddf4"
  },
  "BN": {
    "name": "Brunei Darussalam",
    "dial_code": "+673",
    "code": "BN",
    "flag": "\ud83c\udde7\ud83c\uddf3"
  },
  "BG": {
    "name": "Bulgaria",
    "dial_code": "+359",
    "code": "BG",
    "flag": "\ud83c\udde7\ud83c\uddec"
  },
  "BF": {
    "name": "Burkina Faso",
    "dial_code": "+226",
    "code": "BF",
    "flag": "\ud83c\udde7\ud83c\uddeb"
  },
  "BI": {
    "name": "Burundi",
    "dial_code": "+257",
    "code": "BI",
    "flag": "\ud83c\udde7\ud83c\uddee"
  },
  "KH": {
    "name": "Cambodia",
    "dial_code": "+855",
    "code": "KH",
    "flag": "\ud83c\uddf0\ud83c\udded"
  },
  "CM": {
    "name": "Cameroon",
    "dial_code": "+237",
    "code": "CM",
    "flag": "\ud83c\udde8\ud83c\uddf2"
  },
  "CA": {
    "name": "Canada",
    "dial_code": "+1",
    "code": "CA",
    "flag": "\ud83c\udde8\ud83c\udde6"
  },
  "CV": {
    "name": "Cape Verde",
    "dial_code": "+238",
    "code": "CV",
    "flag": "\ud83c\udde8\ud83c\uddfb"
  },
  "KY": {
    "name": "Cayman Islands",
    "dial_code": "+ 345",
    "code": "KY",
    "flag": "\ud83c\uddf0\ud83c\uddfe"
  },
  "CF": {
    "name": "Central African Republic",
    "dial_code": "+236",
    "code": "CF",
    "flag": "\ud83c\udde8\ud83c\uddeb"
  },
  "TD": {
    "name": "Chad",
    "dial_code": "+235",
    "code": "TD",
    "flag": "\ud83c\uddf9\ud83c\udde9"
  },
  "CL": {
    "name": "Chile",
    "dial_code": "+56",
    "code": "CL",
    "flag": "\ud83c\udde8\ud83c\uddf1"
  },
  "CN": {
    "name": "China",
    "dial_code": "+86",
    "code": "CN",
    "flag": "\ud83c\udde8\ud83c\uddf3"
  },
  "CX": {
    "name": "Christmas Island",
    "dial_code": "+61",
    "code": "CX",
    "flag": "\ud83c\udde8\ud83c\uddfd"
  },
  "CC": {
    "name": "Cocos (Keeling) Islands",
    "dial_code": "+61",
    "code": "CC",
    "flag": "\ud83c\udde8\ud83c\udde8"
  },
  "CO": {
    "name": "Colombia",
    "dial_code": "+57",
    "code": "CO",
    "flag": "\ud83c\udde8\ud83c\uddf4"
  },
  "KM": {
    "name": "Comoros",
    "dial_code": "+269",
    "code": "KM",
    "flag": "\ud83c\uddf0\ud83c\uddf2"
  },
  "CG": {
    "name": "Congo",
    "dial_code": "+242",
    "code": "CG",
    "flag": "\ud83c\udde8\ud83c\uddec"
  },
  "CD": {
    "name": "Congo, The Democratic Republic of the Congo",
    "dial_code": "+243",
    "code": "CD",
    "flag": "\ud83c\udde8\ud83c\udde9"
  },
  "CK": {
    "name": "Cook Islands",
    "dial_code": "+682",
    "code": "CK",
    "flag": "\ud83c\udde8\ud83c\uddf0"
  },
  "CR": {
    "name": "Costa Rica",
    "dial_code": "+506",
    "code": "CR",
    "flag": "\ud83c\udde8\ud83c\uddf7"
  },
  "CI": {
    "name": "Cote d'Ivoire",
    "dial_code": "+225",
    "code": "CI",
    "flag": "\ud83c\udde8\ud83c\uddee"
  },
  "HR": {
    "name": "Croatia",
    "dial_code": "+385",
    "code": "HR",
    "flag": "\ud83c\udded\ud83c\uddf7"
  },
  "CU": {
    "name": "Cuba",
    "dial_code": "+53",
    "code": "CU",
    "flag": "\ud83c\udde8\ud83c\uddfa"
  },
  "CY": {
    "name": "Cyprus",
    "dial_code": "+357",
    "code": "CY",
    "flag": "\ud83c\udde8\ud83c\uddfe"
  },
  "CZ": {
    "name": "Czech Republic",
    "dial_code": "+420",
    "code": "CZ",
    "flag": "\ud83c\udde8\ud83c\uddff"
  },
  "DK": {
    "name": "Denmark",
    "dial_code": "+45",
    "code": "DK",
    "flag": "\ud83c\udde9\ud83c\uddf0"
  },
  "DJ": {
    "name": "Djibouti",
    "dial_code": "+253",
    "code": "DJ",
    "flag": "\ud83c\udde9\ud83c\uddef"
  },
  "DM": {
    "name": "Dominica",
    "dial_code": "+1767",
    "code": "DM",
    "flag": "\ud83c\udde9\ud83c\uddf2"
  },
  "DO": {
    "name": "Dominican Republic",
    "dial_code": "+1849",
    "code": "DO",
    "flag": "\ud83c\udde8\ud83c\udde9"
  },
  "EC": {
    "name": "Ecuador",
    "dial_code": "+593",
    "code": "EC",
    "flag": "\ud83c\uddea\ud83c\udde8"
  },
  "EG": {
    "name": "Egypt",
    "dial_code": "+20",
    "code": "EG",
    "flag": "\ud83c\uddea\ud83c\uddec"
  },
  "SV": {
    "name": "El Salvador",
    "dial_code": "+503",
    "code": "SV",
    "flag": "\ud83c\uddf8\ud83c\uddfb"
  },
  "GQ": {
    "name": "Equatorial Guinea",
    "dial_code": "+240",
    "code": "GQ",
    "flag": "\ud83c\uddec\ud83c\uddf6"
  },
  "ER": {
    "name": "Eritrea",
    "dial_code": "+291",
    "code": "ER",
    "flag": "\ud83c\uddea\ud83c\uddf7"
  },
  "EE": {
    "name": "Estonia",
    "dial_code": "+372",
    "code": "EE",
    "flag": "\ud83c\uddea\ud83c\uddea"
  },
  "ET": {
    "name": "Ethiopia",
    "dial_code": "+251",
    "code": "ET",
    "flag": "\ud83c\uddea\ud83c\uddf9"
  },
  "FK": {
    "name": "Falkland Islands (Malvinas)",
    "dial_code": "+500",
    "code": "FK",
    "flag": "\ud83c\uddeb\ud83c\uddf0"
  },
  "FO": {
    "name": "Faroe Islands",
    "dial_code": "+298",
    "code": "FO",
    "flag": "\ud83c\uddeb\ud83c\uddf4"
  },
  "FJ": {
    "name": "Fiji",
    "dial_code": "+679",
    "code": "FJ",
    "flag": "\ud83c\uddeb\ud83c\uddef"
  },
  "FI": {
    "name": "Finland",
    "dial_code": "+358",
    "code": "FI",
    "flag": "\ud83c\uddeb\ud83c\uddee"
  },
  "FR": {
    "name": "France",
    "dial_code": "+33",
    "code": "FR",
    "flag": "\ud83c\uddeb\ud83c\uddf7"
  },
  "GF": {
    "name": "French Guiana",
    "dial_code": "+594",
    "code": "GF",
    "flag": "\ud83c\uddec\ud83c\uddeb"
  },
  "PF": {
    "name": "French Polynesia",
    "dial_code": "+689",
    "code": "PF",
    "flag": "\ud83c\uddf5\ud83c\uddeb"
  },
  "TF": {
    "name": "French Southern Territories",
    "dial_code": "+262",
    "code": "TF",
    "flag": "\ud83c\uddf9\ud83c\uddeb"
  },
  "GA": {
    "name": "Gabon",
    "dial_code": "+241",
    "code": "GA",
    "flag": "\ud83c\uddec\ud83c\udde6"
  },
  "GM": {
    "name": "Gambia",
    "dial_code": "+220",
    "code": "GM",
    "flag": "\ud83c\uddec\ud83c\uddf2"
  },
  "GE": {
    "name": "Georgia",
    "dial_code": "+995",
    "code": "GE",
    "flag": "\ud83c\uddec\ud83c\uddea"
  },
  "DE": {
    "name": "Germany",
    "dial_code": "+49",
    "code": "DE",
    "flag": "\ud83c\udde9\ud83c\uddea"
  },
  "GH": {
    "name": "Ghana",
    "dial_code": "+233",
    "code": "GH",
    "flag": "\ud83c\uddec\ud83c\udded"
  },
  "GI": {
    "name": "Gibraltar",
    "dial_code": "+350",
    "code": "GI",
    "flag": "\ud83c\uddec\ud83c\uddee"
  },
  "GR": {
    "name": "Greece",
    "dial_code": "+30",
    "code": "GR",
    "flag": "\ud83c\uddec\ud83c\uddf7"
  },
  "GL": {
    "name": "Greenland",
    "dial_code": "+299",
    "code": "GL",
    "flag": "\ud83c\uddec\ud83c\uddf1"
  },
  "GD": {
    "name": "Grenada",
    "dial_code": "+1473",
    "code": "GD",
    "flag": "\ud83c\uddec\ud83c\udde9"
  },
  "GP": {
    "name": "Guadeloupe",
    "dial_code": "+590",
    "code": "GP",
    "flag": "\ud83c\uddec\ud83c\uddf5"
  },
  "GU": {
    "name": "Guam",
    "dial_code": "+1671",
    "code": "GU",
    "flag": "\ud83c\uddec\ud83c\uddfa"
  },
  "GT": {
    "name": "Guatemala",
    "dial_code": "+502",
    "code": "GT",
    "flag": "\ud83c\uddec\ud83c\uddf9"
  },
  "GG": {
    "name": "Guernsey",
    "dial_code": "+44",
    "code": "GG",
    "flag": "\ud83c\uddec\ud83c\uddec"
  },
  "GN": {
    "name": "Guinea",
    "dial_code": "+224",
    "code": "GN",
    "flag": "\ud83c\uddec\ud83c\uddf3"
  },
  "GW": {
    "name": "Guinea-Bissau",
    "dial_code": "+245",
    "code": "GW",
    "flag": "\ud83c\uddec\ud83c\uddfc"
  },
  "GY": {
    "name": "Guyana",
    "dial_code": "+592",
    "code": "GY",
    "flag": "\ud83c\uddec\ud83c\uddfe"
  },
  "HT": {
    "name": "Haiti",
    "dial_code": "+509",
    "code": "HT",
    "flag": "\ud83c\udded\ud83c\uddf9"
  },
  "HM": {
    "name": "Heard Island and Mcdonald Islands",
    "dial_code": "+0",
    "code": "HM",
    "flag": "\ud83c\udff3"
  },
  "VA": {
    "name": "Holy See (Vatican City State)",
    "dial_code": "+379",
    "code": "VA",
    "flag": "\ud83c\uddfb\ud83c\udde6"
  },
  "HN": {
    "name": "Honduras",
    "dial_code": "+504",
    "code": "HN",
    "flag": "\ud83c\udded\ud83c\uddf3"
  },
  "HK": {
    "name": "Hong Kong",
    "dial_code": "+852",
    "code": "HK",
    "flag": "\ud83c\udded\ud83c\uddf0"
  },
  "HU": {
    "name": "Hungary",
    "dial_code": "+36",
    "code": "HU",
    "flag": "\ud83c\udded\ud83c\uddfa"
  },
  "IS": {
    "name": "Iceland",
    "dial_code": "+354",
    "code": "IS",
    "flag": "\ud83c\uddee\ud83c\uddf8"
  },
  "IN": {
    "name": "India",
    "dial_code": "+91",
    "code": "IN",
    "flag": "\ud83c\uddee\ud83c\uddf3"
  },
  "ID": {
    "name": "Indonesia",
    "dial_code": "+62",
    "code": "ID",
    "flag": "\ud83c\uddee\ud83c\udde9"
  },
  "IR": {
    "name": "Iran, Islamic Republic of Persian Gulf",
    "dial_code": "+98",
    "code": "IR",
    "flag": "\ud83c\uddee\ud83c\uddf7"
  },
  "IQ": {
    "name": "Iraq",
    "dial_code": "+964",
    "code": "IQ",
    "flag": "\ud83c\uddee\ud83c\uddf6"
  },
  "IE": {
    "name": "Ireland",
    "dial_code": "+353",
    "code": "IE",
    "flag": "\ud83c\uddee\ud83c\uddea"
  },
  "IM": {
    "name": "Isle of Man",
    "dial_code": "+44",
    "code": "IM",
    "flag": "\ud83c\uddee\ud83c\uddf2"
  },
  "IL": {
    "name": "Israel",
    "dial_code": "+972",
    "code": "IL",
    "flag": "\ud83c\uddee\ud83c\uddf1"
  },
  "IT": {
    "name": "Italy",
    "dial_code": "+39",
    "code": "IT",
    "flag": "\ud83c\uddee\ud83c\uddf9"
  },
  "JM": {
    "name": "Jamaica",
    "dial_code": "+1876",
    "code": "JM",
    "flag": "\ud83c\uddef\ud83c\uddf2"
  },
  "JP": {
    "name": "Japan",
    "dial_code": "+81",
    "code": "JP",
    "flag": "\ud83c\uddef\ud83c\uddf5"
  },
  "JE": {
    "name": "Jersey",
    "dial_code": "+44",
    "code": "JE",
    "flag": "\ud83c\uddef\ud83c\uddea"
  },
  "JO": {
    "name": "Jordan",
    "dial_code": "+962",
    "code": "JO",
    "flag": "\ud83c\uddef\ud83c\uddf4"
  },
  "KZ": {
    "name": "Kazakhstan",
    "dial_code": "+7",
    "code": "KZ",
    "flag": "\ud83c\uddf0\ud83c\uddff"
  },
  "KE": {
    "name": "Kenya",
    "dial_code": "+254",
    "code": "KE",
    "flag": "\ud83c\uddf0\ud83c\uddea"
  },
  "KI": {
    "name": "Kiribati",
    "dial_code": "+686",
    "code": "KI",
    "flag": "\ud83c\uddf0\ud83c\uddee"
  },
  "KP": {
    "name": "Korea, Democratic People's Republic of Korea",
    "dial_code": "+850",
    "code": "KP",
    "flag": "\ud83c\uddf0\ud83c\uddf5"
  },
  "KR": {
    "name": "Korea, Republic of South Korea",
    "dial_code": "+82",
    "code": "KR",
    "flag": "\ud83c\uddf0\ud83c\uddf7"
  },
  "XK": {
    "name": "Kosovo",
    "dial_code": "+383",
    "code": "XK",
    "flag": "\ud83c\uddfd\ud83c\uddf0"
  },
  "KW": {
    "name": "Kuwait",
    "dial_code": "+965",
    "code": "KW",
    "flag": "\ud83c\uddf0\ud83c\uddfc"
  },
  "KG": {
    "name": "Kyrgyzstan",
    "dial_code": "+996",
    "code": "KG",
    "flag": "\ud83c\uddf0\ud83c\uddec"
  },
  "LA": {
    "name": "Laos",
    "dial_code": "+856",
    "code": "LA",
    "flag": "\ud83c\uddf1\ud83c\udde6"
  },
  "LV": {
    "name": "Latvia",
    "dial_code": "+371",
    "code": "LV",
    "flag": "\ud83c\uddf1\ud83c\uddfb"
  },
  "LB": {
    "name": "Lebanon",
    "dial_code": "+961",
    "code": "LB",
    "flag": "\ud83c\uddf1\ud83c\udde7"
  },
  "LS": {
    "name": "Lesotho",
    "dial_code": "+266",
    "code": "LS",
    "flag": "\ud83c\uddf1\ud83c\uddf8"
  },
  "LR": {
    "name": "Liberia",
    "dial_code": "+231",
    "code": "LR",
    "flag": "\ud83c\uddf1\ud83c\uddf7"
  },
  "LY": {
    "name": "Libyan Arab Jamahiriya",
    "dial_code": "+218",
    "code": "LY",
    "flag": "\ud83c\uddf1\ud83c\uddfe"
  },
  "LI": {
    "name": "Liechtenstein",
    "dial_code": "+423",
    "code": "LI",
    "flag": "\ud83c\uddf1\ud83c\uddee"
  },
  "LT": {
    "name": "Lithuania",
    "dial_code": "+370",
    "code": "LT",
    "flag": "\ud83c\uddf1\ud83c\uddf9"
  },
  "LU": {
    "name": "Luxembourg",
    "dial_code": "+352",
    "code": "LU",
    "flag": "\ud83c\uddf1\ud83c\uddfa"
  },
  "MO": {
    "name": "Macao",
    "dial_code": "+853",
    "code": "MO",
    "flag": "\ud83c\uddf2\ud83c\uddf4"
  },
  "MK": {
    "name": "Macedonia",
    "dial_code": "+389",
    "code": "MK",
    "flag": "\ud83c\uddf2\ud83c\uddf0"
  },
  "MG": {
    "name": "Madagascar",
    "dial_code": "+261",
    "code": "MG",
    "flag": "\ud83c\uddf2\ud83c\uddec"
  },
  "MW": {
    "name": "Malawi",
    "dial_code": "+265",
    "code": "MW",
    "flag": "\ud83c\uddf2\ud83c\uddfc"
  },
  "MY": {
    "name": "Malaysia",
    "dial_code": "+60",
    "code": "MY",
    "flag": "\ud83c\uddf2\ud83c\uddfe"
  },
  "MV": {
    "name": "Maldives",
    "dial_code": "+960",
    "code": "MV",
    "flag": "\ud83c\uddf2\ud83c\uddfb"
  },
  "ML": {
    "name": "Mali",
    "dial_code": "+223",
    "code": "ML",
    "flag": "\ud83c\uddf2\ud83c\uddf1"
  },
  "MT": {
    "name": "Malta",
    "dial_code": "+356",
    "code": "MT",
    "flag": "\ud83c\uddf2\ud83c\uddf9"
  },
  "MH": {
    "name": "Marshall Islands",
    "dial_code": "+692",
    "code": "MH",
    "flag": "\ud83c\uddf2\ud83c\udded"
  },
  "MQ": {
    "name": "Martinique",
    "dial_code": "+596",
    "code": "MQ",
    "flag": "\ud83c\uddf2\ud83c\uddf6"
  },
  "MR": {
    "name": "Mauritania",
    "dial_code": "+222",
    "code": "MR",
    "flag": "\ud83c\uddf2\ud83c\uddf7"
  },
  "MU": {
    "name": "Mauritius",
    "dial_code": "+230",
    "code": "MU",
    "flag": "\ud83c\uddf2\ud83c\uddfa"
  },
  "YT": {
    "name": "Mayotte",
    "dial_code": "+262",
    "code": "YT",
    "flag": "\ud83c\uddfe\ud83c\uddf9"
  },
  "MX": {
    "name": "Mexico",
    "dial_code": "+52",
    "code": "MX",
    "flag": "\ud83c\uddf2\ud83c\uddfd"
  },
  "FM": {
    "name": "Micronesia, Federated States of Micronesia",
    "dial_code": "+691",
    "code": "FM",
    "flag": "\ud83c\uddeb\ud83c\uddf2"
  },
  "MD": {
    "name": "Moldova",
    "dial_code": "+373",
    "code": "MD",
    "flag": "\ud83c\uddf2\ud83c\udde9"
  },
  "MC": {
    "name": "Monaco",
    "dial_code": "+377",
    "code": "MC",
    "flag": "\ud83c\uddf2\ud83c\udde8"
  },
  "MN": {
    "name": "Mongolia",
    "dial_code": "+976",
    "code": "MN",
    "flag": "\ud83c\uddf2\ud83c\uddf3"
  },
  "ME": {
    "name": "Montenegro",
    "dial_code": "+382",
    "code": "ME",
    "flag": "\ud83c\uddf2\ud83c\uddea"
  },
  "MS": {
    "name": "Montserrat",
    "dial_code": "+1664",
    "code": "MS",
    "flag": "\ud83c\uddf2\ud83c\uddf8"
  },
  "MA": {
    "name": "Morocco",
    "dial_code": "+212",
    "code": "MA",
    "flag": "\ud83c\uddf2\ud83c\udde6"
  },
  "MZ": {
    "name": "Mozambique",
    "dial_code": "+258",
    "code": "MZ",
    "flag": "\ud83c\uddf2\ud83c\uddff"
  },
  "MM": {
    "name": "Myanmar",
    "dial_code": "+95",
    "code": "MM",
    "flag": "\ud83c\uddf2\ud83c\uddf2"
  },
  "NA": {
    "name": "Namibia",
    "dial_code": "+264",
    "code": "NA",
    "flag": "\ud83c\uddf3\ud83c\udde6"
  },
  "NR": {
    "name": "Nauru",
    "dial_code": "+674",
    "code": "NR",
    "flag": "\ud83c\uddf3\ud83c\uddf7"
  },
  "NP": {
    "name": "Nepal",
    "dial_code": "+977",
    "code": "NP",
    "flag": "\ud83c\uddf3\ud83c\uddf5"
  },
  "NL": {
    "name": "Netherlands",
    "dial_code": "+31",
    "code": "NL",
    "flag": "\ud83c\uddf3\ud83c\uddf1"
  },
  "AN": {
    "name": "Netherlands Antilles",
    "dial_code": "+599",
    "code": "AN",
    "flag": "\ud83c\uddf3\ud83c\uddf1"
  },
  "NC": {
    "name": "New Caledonia",
    "dial_code": "+687",
    "code": "NC",
    "flag": "\ud83c\uddf3\ud83c\udde8"
  },
  "NZ": {
    "name": "New Zealand",
    "dial_code": "+64",
    "code": "NZ",
    "flag": "\ud83c\uddf3\ud83c\uddff"
  },
  "NI": {
    "name": "Nicaragua",
    "dial_code": "+505",
    "code": "NI",
    "flag": "\ud83c\uddf3\ud83c\uddee"
  },
  "NE": {
    "name": "Niger",
    "dial_code": "+227",
    "code": "NE",
    "flag": "\ud83c\uddf3\ud83c\uddea"
  },
  "NG": {
    "name": "Nigeria",
    "dial_code": "+234",
    "code": "NG",
    "flag": "\ud83c\uddf3\ud83c\uddec"
  },
  "NU": {
    "name": "Niue",
    "dial_code": "+683",
    "code": "NU",
    "flag": "\ud83c\uddf3\ud83c\uddfa"
  },
  "NF": {
    "name": "Norfolk Island",
    "dial_code": "+672",
    "code": "NF",
    "flag": "\ud83c\uddf3\ud83c\uddeb"
  },
  "MP": {
    "name": "Northern Mariana Islands",
    "dial_code": "+1670",
    "code": "MP",
    "flag": "\ud83c\udff3"
  },
  "NO": {
    "name": "Norway",
    "dial_code": "+47",
    "code": "NO",
    "flag": "\ud83c\uddf3\ud83c\uddf4"
  },
  "OM": {
    "name": "Oman",
    "dial_code": "+968",
    "code": "OM",
    "flag": "\ud83c\uddf4\ud83c\uddf2"
  },
  "PK": {
    "name": "Pakistan",
    "dial_code": "+92",
    "code": "PK",
    "flag": "\ud83c\uddf5\ud83c\uddf0"
  },
  "PW": {
    "name": "Palau",
    "dial_code": "+680",
    "code": "PW",
    "flag": "\ud83c\uddf5\ud83c\uddfc"
  },
  "PS": {
    "name": "Palestinian Territory, Occupied",
    "dial_code": "+970",
    "code": "PS",
    "flag": "\ud83c\uddf5\ud83c\uddf8"
  },
  "PA": {
    "name": "Panama",
    "dial_code": "+507",
    "code": "PA",
    "flag": "\ud83c\uddf5\ud83c\udde6"
  },
  "PG": {
    "name": "Papua New Guinea",
    "dial_code": "+675",
    "code": "PG",
    "flag": "\ud83c\uddf5\ud83c\uddec"
  },
  "PY": {
    "name": "Paraguay",
    "dial_code": "+595",
    "code": "PY",
    "flag": "\ud83c\uddf5\ud83c\uddfe"
  },
  "PE": {
    "name": "Peru",
    "dial_code": "+51",
    "code": "PE",
    "flag": "\ud83c\uddf5\ud83c\uddea"
  },
  "PH": {
    "name": "Philippines",
    "dial_code": "+63",
    "code": "PH",
    "flag": "\ud83c\uddf5\ud83c\udded"
  },
  "PN": {
    "name": "Pitcairn",
    "dial_code": "+64",
    "code": "PN",
    "flag": "\ud83c\uddf5\ud83c\uddf3"
  },
  "PL": {
    "name": "Poland",
    "dial_code": "+48",
    "code": "PL",
    "flag": "\ud83c\uddf5\ud83c\uddf1"
  },
  "PT": {
    "name": "Portugal",
    "dial_code": "+351",
    "code": "PT",
    "flag": "\ud83c\uddf5\ud83c\uddf9"
  },
  "PR": {
    "name": "Puerto Rico",
    "dial_code": "+1939",
    "code": "PR",
    "flag": "\ud83c\uddf5\ud83c\uddf7"
  },
  "QA": {
    "name": "Qatar",
    "dial_code": "+974",
    "code": "QA",
    "flag": "\ud83c\uddf6\ud83c\udde6"
  },
  "RO": {
    "name": "Romania",
    "dial_code": "+40",
    "code": "RO",
    "flag": "\ud83c\uddf7\ud83c\uddf4"
  },
  "RU": {
    "name": "Russia",
    "dial_code": "+7",
    "code": "RU",
    "flag": "\ud83c\uddf7\ud83c\uddfa"
  },
  "RW": {
    "name": "Rwanda",
    "dial_code": "+250",
    "code": "RW",
    "flag": "\ud83c\uddf7\ud83c\uddfc"
  },
  "RE": {
    "name": "Reunion",
    "dial_code": "+262",
    "code": "RE",
    "flag": "\ud83c\uddeb\ud83c\uddf7"
  },
  "BL": {
    "name": "Saint Barthelemy",
    "dial_code": "+590",
    "code": "BL",
    "flag": "\ud83c\udde7\ud83c\uddf1"
  },
  "SH": {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "dial_code": "+290",
    "code": "SH",
    "flag": "\ud83c\uddf8\ud83c\udded"
  },
  "KN": {
    "name": "Saint Kitts and Nevis",
    "dial_code": "+1869",
    "code": "KN",
    "flag": "\ud83c\uddf0\ud83c\uddf3"
  },
  "LC": {
    "name": "Saint Lucia",
    "dial_code": "+1758",
    "code": "LC",
    "flag": "\ud83c\uddf1\ud83c\udde8"
  },
  "MF": {
    "name": "Saint Martin",
    "dial_code": "+590",
    "code": "MF",
    "flag": "\ud83c\udff3"
  },
  "PM": {
    "name": "Saint Pierre and Miquelon",
    "dial_code": "+508",
    "code": "PM",
    "flag": "\ud83c\uddf5\ud83c\uddf2"
  },
  "VC": {
    "name": "Saint Vincent and the Grenadines",
    "dial_code": "+1784",
    "code": "VC",
    "flag": "\ud83c\uddfb\ud83c\udde8"
  },
  "WS": {
    "name": "Samoa",
    "dial_code": "+685",
    "code": "WS",
    "flag": "\ud83c\uddfc\ud83c\uddf8"
  },
  "SM": {
    "name": "San Marino",
    "dial_code": "+378",
    "code": "SM",
    "flag": "\ud83c\uddf8\ud83c\uddf2"
  },
  "ST": {
    "name": "Sao Tome and Principe",
    "dial_code": "+239",
    "code": "ST",
    "flag": "\ud83c\uddf8\ud83c\uddf9"
  },
  "SA": {
    "name": "Saudi Arabia",
    "dial_code": "+966",
    "code": "SA",
    "flag": "\ud83c\uddf8\ud83c\udde6"
  },
  "SN": {
    "name": "Senegal",
    "dial_code": "+221",
    "code": "SN",
    "flag": "\ud83c\uddf8\ud83c\uddf3"
  },
  "RS": {
    "name": "Serbia",
    "dial_code": "+381",
    "code": "RS",
    "flag": "\ud83c\uddf7\ud83c\uddf8"
  },
  "SC": {
    "name": "Seychelles",
    "dial_code": "+248",
    "code": "SC",
    "flag": "\ud83c\uddf8\ud83c\udde8"
  },
  "SL": {
    "name": "Sierra Leone",
    "dial_code": "+232",
    "code": "SL",
    "flag": "\ud83c\uddf8\ud83c\uddf1"
  },
  "SG": {
    "name": "Singapore",
    "dial_code": "+65",
    "code": "SG",
    "flag": "\ud83c\uddf8\ud83c\uddec"
  },
  "SK": {
    "name": "Slovakia",
    "dial_code": "+421",
    "code": "SK",
    "flag": "\ud83c\uddf8\ud83c\uddf0"
  },
  "SI": {
    "name": "Slovenia",
    "dial_code": "+386",
    "code": "SI",
    "flag": "\ud83c\uddf8\ud83c\uddee"
  },
  "SB": {
    "name": "Solomon Islands",
    "dial_code": "+677",
    "code": "SB",
    "flag": "\ud83c\uddf8\ud83c\udde7"
  },
  "SO": {
    "name": "Somalia",
    "dial_code": "+252",
    "code": "SO",
    "flag": "\ud83c\uddf8\ud83c\uddf4"
  },
  "ZA": {
    "name": "South Africa",
    "dial_code": "+27",
    "code": "ZA",
    "flag": "\ud83c\uddff\ud83c\udde6"
  },
  "SS": {
    "name": "South Sudan",
    "dial_code": "+211",
    "code": "SS",
    "flag": "\ud83c\uddf8\ud83c\uddf8"
  },
  "GS": {
    "name": "South Georgia and the South Sandwich Islands",
    "dial_code": "+500",
    "code": "GS",
    "flag": "\ud83c\uddec\ud83c\uddf8"
  },
  "ES": {
    "name": "Spain",
    "dial_code": "+34",
    "code": "ES",
    "flag": "\ud83c\uddea\ud83c\uddf8"
  },
  "LK": {
    "name": "Sri Lanka",
    "dial_code": "+94",
    "code": "LK",
    "flag": "\ud83c\uddf1\ud83c\uddf0"
  },
  "SD": {
    "name": "Sudan",
    "dial_code": "+249",
    "code": "SD",
    "flag": "\ud83c\uddf8\ud83c\udde9"
  },
  "SR": {
    "name": "Suriname",
    "dial_code": "+597",
    "code": "SR",
    "flag": "\ud83c\uddf8\ud83c\uddf7"
  },
  "SJ": {
    "name": "Svalbard and Jan Mayen",
    "dial_code": "+47",
    "code": "SJ",
    "flag": "\ud83c\udde9\ud83c\uddf0"
  },
  "SZ": {
    "name": "Swaziland",
    "dial_code": "+268",
    "code": "SZ",
    "flag": "\ud83c\uddf8\ud83c\uddff"
  },
  "SE": {
    "name": "Sweden",
    "dial_code": "+46",
    "code": "SE",
    "flag": "\ud83c\uddf8\ud83c\uddea"
  },
  "CH": {
    "name": "Switzerland",
    "dial_code": "+41",
    "code": "CH",
    "flag": "\ud83c\udde8\ud83c\udded"
  },
  "SY": {
    "name": "Syrian Arab Republic",
    "dial_code": "+963",
    "code": "SY",
    "flag": "\ud83c\uddf8\ud83c\uddfe"
  },
  "TW": {
    "name": "Taiwan",
    "dial_code": "+886",
    "code": "TW",
    "flag": "\ud83c\uddf9\ud83c\uddfc"
  },
  "TJ": {
    "name": "Tajikistan",
    "dial_code": "+992",
    "code": "TJ",
    "flag": "\ud83c\uddf9\ud83c\uddef"
  },
  "TZ": {
    "name": "Tanzania",
    "dial_code": "+255",
    "code": "TZ",
    "flag": "\ud83c\uddf9\ud83c\uddff"
  },
  "TH": {
    "name": "Thailand",
    "dial_code": "+66",
    "code": "TH",
    "flag": "\ud83c\uddf9\ud83c\udded"
  },
  "TL": {
    "name": "Timor-Leste",
    "dial_code": "+670",
    "code": "TL",
    "flag": "\ud83c\uddf9\ud83c\uddf1"
  },
  "TG": {
    "name": "Togo",
    "dial_code": "+228",
    "code": "TG",
    "flag": "\ud83c\uddf9\ud83c\uddec"
  },
  "TK": {
    "name": "Tokelau",
    "dial_code": "+690",
    "code": "TK",
    "flag": "\ud83c\uddf9\ud83c\uddf0"
  },
  "TO": {
    "name": "Tonga",
    "dial_code": "+676",
    "code": "TO",
    "flag": "\ud83c\uddf9\ud83c\uddf4"
  },
  "TT": {
    "name": "Trinidad and Tobago",
    "dial_code": "+1868",
    "code": "TT",
    "flag": "\ud83c\uddf9\ud83c\uddf9"
  },
  "TN": {
    "name": "Tunisia",
    "dial_code": "+216",
    "code": "TN",
    "flag": "\ud83c\uddf9\ud83c\uddf3"
  },
  "TR": {
    "name": "Turkey",
    "dial_code": "+90",
    "code": "TR",
    "flag": "\ud83c\uddf9\ud83c\uddf7"
  },
  "TM": {
    "name": "Turkmenistan",
    "dial_code": "+993",
    "code": "TM",
    "flag": "\ud83c\uddf9\ud83c\uddf2"
  },
  "TC": {
    "name": "Turks and Caicos Islands",
    "dial_code": "+1649",
    "code": "TC",
    "flag": "\ud83c\uddf9\ud83c\udde8"
  },
  "TV": {
    "name": "Tuvalu",
    "dial_code": "+688",
    "code": "TV",
    "flag": "\ud83c\uddf9\ud83c\uddfb"
  },
  "UG": {
    "name": "Uganda",
    "dial_code": "+256",
    "code": "UG",
    "flag": "\ud83c\uddfa\ud83c\uddec"
  },
  "UA": {
    "name": "Ukraine",
    "dial_code": "+380",
    "code": "UA",
    "flag": "\ud83c\uddfa\ud83c\udde6"
  },
  "AE": {
    "name": "United Arab Emirates",
    "dial_code": "+971",
    "code": "AE",
    "flag": "\ud83c\udde6\ud83c\uddea"
  },
  "GB": {
    "name": "United Kingdom",
    "dial_code": "+44",
    "code": "GB",
    "flag": "\ud83c\uddec\ud83c\udde7"
  },
  "US": {
    "name": "United States",
    "dial_code": "+1",
    "code": "US",
    "flag": "\ud83c\uddfa\ud83c\uddf8"
  },
  "UY": {
    "name": "Uruguay",
    "dial_code": "+598",
    "code": "UY",
    "flag": "\ud83c\uddfa\ud83c\uddfe"
  },
  "UZ": {
    "name": "Uzbekistan",
    "dial_code": "+998",
    "code": "UZ",
    "flag": "\ud83c\uddfa\ud83c\uddff"
  },
  "VU": {
    "name": "Vanuatu",
    "dial_code": "+678",
    "code": "VU",
    "flag": "\ud83c\uddfb\ud83c\uddfa"
  },
  "VE": {
    "name": "Venezuela",
    "dial_code": "+58",
    "code": "VE",
    "flag": "\ud83c\uddfb\ud83c\uddea"
  },
  "VN": {
    "name": "Vietnam",
    "dial_code": "+84",
    "code": "VN",
    "flag": "\ud83c\uddfb\ud83c\uddf3"
  },
  "VG": {
    "name": "Virgin Islands, British",
    "dial_code": "+1284",
    "code": "VG",
    "flag": "\ud83c\uddfb\ud83c\uddec"
  },
  "VI": {
    "name": "Virgin Islands, U.S.",
    "dial_code": "+1340",
    "code": "VI",
    "flag": "\ud83c\uddfb\ud83c\uddee"
  },
  "WF": {
    "name": "Wallis and Futuna",
    "dial_code": "+681",
    "code": "WF",
    "flag": "\ud83c\uddfc\ud83c\uddeb"
  },
  "YE": {
    "name": "Yemen",
    "dial_code": "+967",
    "code": "YE",
    "flag": "\ud83c\uddfe\ud83c\uddea"
  },
  "ZM": {
    "name": "Zambia",
    "dial_code": "+260",
    "code": "ZM",
    "flag": "\ud83c\uddff\ud83c\uddf2"
  },
  "ZW": {
    "name": "Zimbabwe",
    "dial_code": "+263",
    "code": "ZW",
    "flag": "\ud83c\uddff\ud83c\uddfc"
  }
}

export { countries, Country }
